import React from 'react'
import './profile.css'
import FormDivider from '../../components/FormDivider/formDivider'

export default function Profile() {


    return (
        <div className='page-container profile_container'>
            <div className='profile_wrapper'>
                <h4 className='heading'>My Account</h4>

                <div className='profile_container__fields'>

                    <div className='center-x profile_container__field_container'>
                        <div className='profile_container__field profile_container__field-image'>
                            <div className='center-y'>
                                <img src='/assets/profile.png' />
                                <p className='field_title'> Upload your profile picture </p>
                            </div>
                            <button className='btn-secondary'>
                                Upload photo
                            </button>
                        </div>
                        <div className='divider'></div>
                    </div>

                    <div className='center-x profile_container__field_container'>
                        <div className='profile_container__field profile_container__field-image'>
                            <div className=''>
                                <p className='field_title'>Name</p>
                                <p className='field_value'> Ravindra Ravindra </p>
                            </div>
                            <button className='btn-secondary'>
                                Edit
                            </button>
                        </div>
                        <div className='divider'></div>
                    </div>

                    <div className='center-x profile_container__field_container'>
                        <div className='profile_container__field profile_container__field-image'>
                            <div className=''>
                                <p className='field_title'>Email Address</p>
                                <p className='field_value'> Ravindra@gmail.com </p>
                            </div>
                            <button className='btn-secondary'>
                                Edit
                            </button>
                        </div>
                        <div className='divider'></div>
                    </div>

                    <div className='center-x profile_container__field_container'>
                        <div className='profile_container__field profile_container__field-image'>
                            <div className=''>
                                <p className='field_title'>Password</p>
                                <p className='field_value'> Send link to reset my password. </p>
                            </div>
                            <button className='btn-secondary'>
                                Edit
                            </button>
                        </div>
                    </div>

                </div>

            </div>
        </div>
    )
}
